<mat-radio-group gdColumns="1fr" gdGap="16px" (change)="select($event)" [value]="selected">
    <mat-radio-button *ngFor="let option of options" [value]="option.value">
        {{ option.label }}
    </mat-radio-button>
</mat-radio-group>
